module.exports = __webpack_public_path__ + "img/csjz.30590668.svg";